// src\pages\TermsPage.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import PolicySwitcher from '../components/ui/policySwitcher';
import { useTranslation } from 'react-i18next';

const TermsContainer = styled(Container)`
  max-width: 800px;
  margin: auto;
  color: #fff;
  border-radius: 8px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const StyledP = styled.p`
  color: #b8b8b8;
  margin-bottom: 0;
`;

const StyledLink = styled.a`
  color: #00aaff;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    color: #ffcc00;
    text-decoration: underline;
  }
`;

const StyledH = styled.h5``;

const SupportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
const SupportEmailMailTo = 'mailto:' + SupportEmail;

const TermsPage = ({hidePolicySwitcher = false}) => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('termsPage.title')} />
      {!hidePolicySwitcher && <PolicySwitcher />}
      <TermsContainer>
        <Section>
          <StyledH>{t('termsPage.introduction.heading')}</StyledH>
          <StyledP>{t('termsPage.introduction.text')}</StyledP>
        </Section>
        <hr />
        <Section>
          <StyledH>{t('termsPage.multiAccount.heading')}</StyledH>
          <StyledP>{t('termsPage.multiAccount.text1')}</StyledP>
          <StyledP>
            {t('termsPage.multiAccount.text2')}{' '}
            <StyledLink href={SupportEmailMailTo}>{SupportEmail}</StyledLink>.
          </StyledP>
          <StyledP>{t('termsPage.multiAccount.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.pkRule.heading')}</StyledH>
          <StyledP>{t('termsPage.pkRule.text1')}</StyledP>
          <StyledP>{t('termsPage.pkRule.text2')}</StyledP>
          <StyledP>{t('termsPage.pkRule.text3')}</StyledP>
          <StyledP>{t('termsPage.pkRule.text4')}</StyledP>
          <StyledP>{t('termsPage.pkRule.text5')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.questRule.heading')}</StyledH>
          <StyledP>{t('termsPage.questRule.text')}</StyledP>
          <StyledP>
            <strong>{t('termsPage.questRule.exceptionLabel')}</strong> {t('termsPage.questRule.exceptionText')}
          </StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.naming.heading')}</StyledH>
          <StyledP>{t('termsPage.naming.text1')}</StyledP>
          <StyledP>{t('termsPage.naming.text2')}</StyledP>
          <StyledP>{t('termsPage.naming.text3')}</StyledP>
          <StyledP>{t('termsPage.naming.text4')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.botBug.heading')}</StyledH>
          <StyledP>{t('termsPage.botBug.text1')}</StyledP>
          <StyledP>{t('termsPage.botBug.text2')}</StyledP>
          <StyledP>{t('termsPage.botBug.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.begging.heading')}</StyledH>
          <StyledP>{t('termsPage.begging.text')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.advertising.heading')}</StyledH>
          <StyledP>{t('termsPage.advertising.text1')}</StyledP>
          <StyledP>{t('termsPage.advertising.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.trading.heading')}</StyledH>
          <StyledP>{t('termsPage.trading.text1')}</StyledP>
          <StyledP>{t('termsPage.trading.text2')}</StyledP>
          <StyledP>{t('termsPage.trading.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.insults.heading')}</StyledH>
          <StyledP>{t('termsPage.insults.text')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.fairUse.heading')}</StyledH>
          <StyledP>{t('termsPage.fairUse.text')}</StyledP>
          <StyledP>{t('termsPage.fairUse.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.userAgreement.heading')}</StyledH>
          <StyledP>{t('termsPage.userAgreement.text1')}</StyledP>
          <StyledP>{t('termsPage.userAgreement.text2')}</StyledP>
          <StyledP>{t('termsPage.userAgreement.text3')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.serverDowntime.heading')}</StyledH>
          <StyledP>{t('termsPage.serverDowntime.text1')}</StyledP>
          <StyledP>{t('termsPage.serverDowntime.text2')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.virtualCurrency.heading')}</StyledH>
          <StyledP>{t('termsPage.virtualCurrency.text1')}</StyledP>
          <StyledP>{t('termsPage.virtualCurrency.text2')}</StyledP>
          <StyledP>{t('termsPage.virtualCurrency.text3')}</StyledP>
          <StyledP>{t('termsPage.virtualCurrency.text4')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('termsPage.administration.heading')}</StyledH>
          <StyledP>{t('termsPage.administration.text1')}</StyledP>
          <StyledP>{t('termsPage.administration.text2')}</StyledP>
          <StyledP>{t('termsPage.administration.text3')}</StyledP>
          <StyledP>{t('termsPage.administration.text4')}</StyledP>
        </Section>
      </TermsContainer>
    </PageContentComponent>
  );
};

export default TermsPage;
